import Grid from '@mui/material/Grid';
import './print.scss';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DashedInput } from './input';
import { useReactToPrint } from 'react-to-print';
import { useEffect, useRef, useState } from 'react';
import { storeOrder } from '../../services/api/api';
import PrintTemplate from './print_template';
import { AxiosResponse } from 'axios';
import { NumberToString } from '../../services/to_wrtten_number';

import { useAPI } from '../../services/hoc/useAPI';
import { ContentNode } from 'react-to-print/lib/types/ContentNode';
import { money_unit } from './common';
import PrintTemplatePrices from './print_template_prices';



interface iProps {
  data?: storeOrder;
  close: Function;
  setWait?: Function;
  tax_percent:number
}
export const PrintPrices = ({ data, close, setWait,tax_percent }: iProps) => {
 
  const api = useAPI()
  const [order, setOrder] = useState<storeOrder>();
  const number_to_string = new NumberToString()
  const componenetRef = useRef<ContentNode>(null);

  const handlePrint = useReactToPrint({
    contentRef:  componenetRef,
    onAfterPrint: () => close(),
    documentTitle: 'أمر شغل'
  });

  

  useEffect(() => {
   
    if (typeof data === 'object') {
      setOrder(data);
    } else {
      if (data) {
        api
          .orders()
          .show({ id: parseInt(data) })
          .then((res: AxiosResponse) => {
            if (setWait) setWait(false);

            setOrder(res.data.data);
          })
          .catch((err: any) => {
            console.log(err);
          });
      }
    }
  }, [data]);
  useEffect(() => {
    if (order) {
      handlePrint();
    }
  }, [order]);

  let total = data?.order_details?.reduce((ac, cur) => ac = ac + (cur.total_price ?? 0), 0)
  let total_after_tax = total ?( total * (tax_percent/100) ) + total : 0
  let written_total = number_to_string.NumToStr(parseFloat((total_after_tax??0).toString()).toFixed(2))

  return (


    <div
      ref={componenetRef as any}
      className="printMe"
      style={{ minHeight:  'auto' }}
    >

      <PrintTemplatePrices

        title_ar='مراجعة الطلبية'
        //title_en='Quotation'
        order_no={order?.order_no}
      >

        <Grid size={12} container paddingTop={0} marginTop={0}  >
          <Grid
            
            container
            size={12}
            marginBottom={4}
            paddingBottom={4}
            padding={0}
            justifyContent="flex-end">


          </Grid>
          <Grid  container size={12} marginBottom={1} >
            <Grid  size={12} >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{ border: '1px dashed black' }}>
                      المسلسل
                    </TableCell>
                    
                    
                    <TableCell
                      style={{ border: '1px dashed black' }}>
                      الصنف

                    </TableCell>
                    
                    <TableCell
                      style={{ border: '1px dashed black' }}>
                      الخدمة
                    </TableCell>

                  <TableCell
                      style={{ border: '1px dashed black' }}>
                      رمز القطعة

                    </TableCell>
                    
                    <TableCell
                      style={{ border: '1px dashed black' }}>
                      العرض
                    </TableCell>


                    <TableCell
                      style={{ border: '1px dashed black' }}>
                      الطول
                    </TableCell>
                                        <TableCell
                      style={{ border: '1px dashed black' }}>
العدد                      
                    </TableCell>
                   <TableCell
                      style={{ border: '1px dashed black' }}>
                      <span>الكمية</span>
                     
                    </TableCell>
                    {/* <TableCell
                      style={{ border: '1px dashed black' }}>
                      السعر الافرادي
                    </TableCell>
                    <TableCell
                      style={{ border: '1px dashed black' }}>
                      السعر الاجمالي
                    </TableCell> */}
                   

                  </TableRow>
                </TableHead>
                <TableBody>
                  {order?.order_details?.map((ele, index) =>
                    <TableRow>
                      <TableCell
                        style={{ border: '1px solid #a7a4a4' }}
                        className=" less_spaces">
                        {index + 1}
                      </TableCell>
                     


                      <TableCell
                        style={{ border: '1px solid #a7a4a4',textAlign:'left' ,paddingLeft:'4px'}}
                        className='less_spaces'>
                        {ele?.glass?.name}
                      </TableCell>
                       
                      <TableCell
                        style={{ border: '1px solid #a7a4a4',textAlign:'left',paddingLeft:'4px' }}
                        className="less_spaces"
                      >
                        {ele.glass_work?.name}
                      </TableCell>
                         <TableCell
                        style={{ border: '1px solid #a7a4a4',textAlign:'left',paddingLeft:'4px' }}
                        className="less_spaces"
                      >
                        {ele.piece_code}
                      </TableCell>
                      <TableCell
                        style={{ border: '1px solid #a7a4a4' }}
                        className=" less_spaces">
                        {ele.width}
                      </TableCell>
                      <TableCell
                        style={{ border: '1px solid #a7a4a4' }}
                        className=" less_spaces">
                        {ele.length}
                      </TableCell>
                      
                      <TableCell
                        style={{ border: '1px solid #a7a4a4' }}
                        className=" less_spaces">
                        {ele.piece_count}
                      </TableCell>
                     
                        <TableCell
                        style={{ border: '1px solid #a7a4a4' }}
                        className=" less_spaces">
                        {ele.glass_work?.unit == 'Piece'?
                        ele.area
                        :
                        ((ele.piece_count??0) * (ele.area??0)).toFixed(2)}
                      </TableCell>
                      {/* <TableCell
                        style={{ border: '1px solid #a7a4a4' }}
                        className="less_spaces"
                      >
                        {ele.price }
                      </TableCell>
                      <TableCell
                        style={{ border: '1px solid #a7a4a4' }}
                        className="less_spaces"
                      >
                        {((ele.total_price??0)).toFixed(2) }
                      </TableCell> */}
                    




                    </TableRow>
                  )
                  }
                </TableBody>
              </Table>
            </Grid>
          </Grid>
  
        </Grid>
      </PrintTemplatePrices>
    </div>


  )
};
